import { useTranslation } from 'react-i18next';
import Switch from '@mui/material/Switch';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { Text1 } from 'components/typography/Texts';
import { ChannelDto, ChannelState, ChannelType } from 'services/notification/notificationService.dto';

const Container = styled.div`
  width: 100%;
  border-bottom: 1px solid ${theme.color.borderGray};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
`;

const StyledSwitch = styled(Switch)`
  &.MuiSwitch-root {
    width: 52px;
    height: 32px;
    padding: 0;
    border-radius: 20px;

    .MuiSwitch-track {
      background-color: ${theme.color.darkGray};
      opacity: 1;
      border-radius: 20px;
    }

    .Mui-checked + .MuiSwitch-track {
      background-color: ${theme.color.red};
      opacity: 1;
    }
  }

  .MuiButtonBase-root {
    padding: 2px;
  }

  .MuiSwitch-thumb {
    width: 28px;
    height: 28px;
    color: ${theme.color.white};
  }
`;

interface Props {
  channel: ChannelDto;
  onPressNotification: (type: ChannelType, state: ChannelState) => void;
}

export const NotificationChannel = ({ channel, onPressNotification }: Props) => {
  const { t } = useTranslation('myProfile');

  const resolveLabel = () => {
    switch (channel.type) {
      case 'SMS':
        return t('notifications.sms');
      case 'EMAIL':
        return t('notifications.email');
      case 'PUSH':
        return t('notifications.push');
    }
  };

  const handleChange = () => {
    onPressNotification(channel.type, channel.state);
  };

  return (
    <Container>
      <Text1>{resolveLabel()}</Text1>
      <StyledSwitch
        checked={channel.state === 'ENABLED'}
        onChange={handleChange}
        data-testid={`notification-switch-${channel.type}`}
      />
    </Container>
  );
};
